import { handleActions, combineActions } from 'redux-actions';
import { fromJS, Map } from 'immutable';

import actions from '../actions';

const { loyalty: loyaltyActions } = actions.customer;

export default handleActions(
  {
    [loyaltyActions.getDescriptiveAsync.toString()]: (hotels, { payload }) => {
      return hotels.set("descriptives", hotels.get("descriptives", Map()).merge(payload));
    },
    [combineActions(
      loyaltyActions.update.toString(), 
      loyaltyActions.get.toString())
    ]: (loyalty, { payload }) => {
      return loyalty.set("user", fromJS(payload));
    },
    [loyaltyActions.loyaltyAsync.toString()]: (loyalty, { payload }) => {
      const loy = fromJS(payload);
      return loyalty.set("data", loy?.size ? loy: null);
    },
    [loyaltyActions.getUserAsync.toString()]: (loyalty, { payload }) => {
      return loyalty.set("user", fromJS(payload));
    },
    [loyaltyActions.getUserPointsAsync.toString()]: (loyalty, { payload }) => {
      
      const loyaltyUser = loyalty.getIn(["user","points"]).merge(payload);
      return loyalty.set("user", loyaltyUser);
    },
    [combineActions(
      loyaltyActions.refreshBlockPointsAsync.toString(), 
      loyaltyActions.setBlockPointsAsync.toString(), 
      loyaltyActions.deleteBlockPointsAsync.toString())
    ]: (loyalty, { payload }) => {
      return loyalty.set("block_points", fromJS(payload));
    }
  },
  Map()
);
